import {Upload} from 'antd';
import ImgCrop from 'antd-img-crop';
import {useState} from 'react';
import {PlusOutlined} from "@ant-design/icons";
const Uploader = () => {
    const [width,setWidth] = useState(16)
    const [height, setHeight] = useState(9)
    const preCheck = (file) => {
        console.log(file) // file.size:文件大小, file.type: 文件类型
        const setRatio = new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.addEventListener(
                'load',
                () => {
                    let img = new Image();
                    img.src = reader.result;
                    img.onload = () => {
                        console.log(img.width,img.height)
                        if (img.width < img.height) {
                            setWidth(9);
                            setHeight(16);
                            // message.error('请上传宽高大于等于 360*550 的封面图！');
                            // reject(new Error('请上传宽高大于等于 360*550 的封面图！'));
                        }
                    };
                },
            );
        })
        setRatio.then(()=>{console.log(width,height);return true});
        // const isPNG = file.type === 'image/png';
        // if (!isPNG) {
        //     message.error(`${file.name} is not a png file`);
        // }
        // return isPNG || Upload.LIST_IGNORE;
    }
    return (
            <Upload
                listType="picture-card"
                beforeUpload={preCheck}
            >
                <PlusOutlined />
            </Upload>
    );
};
export default Uploader;
